<template>
  <div class="visual-element border-t border-solit border-gray-300">
    <RepeaterCollapse ref="repeaterCollapse">
      <template v-slot:header
        ><!-- Pallino + Time -->
        <div class="visual-element__header py-4">
          <span
            class="pointer-number"
            :class="{ 'is-exceeding': isExceeding }"
            >{{ index + 1 }}</span
          >
          <span
            class="timer text-sans-base font-medium px-4"
            :class="{ 'text-error': isExceeding }"
            >{{ timer }}</span
          >
          <span class="text-sans-base font-medium text-gray-800"
            ><input
              style="width:50%"
              type="text"
              placeholder="Dai un nome al contenuto"
              @click="editLabel"
              v-model="currentLabel"
          /></span>
        </div>
      </template>

      <template v-slot:default>
        <div class="visual-element__body pb-20">
          <!-- Select per il tipo -->
          <div class="visual-element__type py-1">
            <div class="row m-0">
              <div class="col-1/4">
                <v-select
                  v-model="currentType"
                  :options="options"
                  :searchable="false"
                  :clearable="false"
                  :reduce="type => type.value"
                />
              </div>
            </div>
          </div>

          <!-- Passo il tipo corrente allo slot -->
          <div class="visual-element__content mt-8 overflow-hidden">
            <slot :type="currentType"></slot>
          </div>
        </div>
      </template>

      <template v-slot:actions>
        <!-- Pulsante cestino -->
        <div class="visual-element__actions">
          <button class="btn-round-icon" @click="$emit('delete', element._id)">
            <IconTrash />
          </button>
        </div>
      </template>
    </RepeaterCollapse>
  </div>
</template>

<script>
/** Icons */
import IconTrash from '@/assets/icons/icon-trash.svg'

/** Components */
import RepeaterCollapse from '@/components/RepeaterCollapse.vue'

export default {
  components: {
    RepeaterCollapse,
    IconTrash,
  },
  props: {
    element: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      default: 0,
    },
    isExceeding: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      options: [
        { value: 'image', label: 'Immagine' },
        { value: 'link', label: 'Url' },
        { value: 'quote', label: 'Citazione' },
        { value: 'video', label: 'YouTube' },
        { value: 'ar', label: 'VR/AR' },
        { value: 'location', label: 'Mappa' },
        { value: 'quiz', label: 'Quiz' },
        { value: 'gallery', label: 'Gallery' },
        { value: 'mux', label: 'Video' },
      ],
    }
  },

  computed: {
    timer() {
      return new Date(this.element.time * 1000).toISOString().substr(11, 8)
    },
    typeLabel() {
      const index = this.options.findIndex(
        option => option.value === this.element.type,
      )
      return this.options[index].label
    },
    currentLabel: {
      get() {
        return this.element.label
      },
      set(value) {
        this.$emit('updateLabel', value)
      },
    },
    currentType: {
      get() {
        return this.element.type
      },
      set(value) {
        this.$emit('update', value)
      },
    },
  },
  methods: {
    editLabel(event) {
      event.stopPropagation()
    },
  },
}
</script>

<style lang="scss" scoped></style>
